<!--
 * @Author: Gaho
 * @Date: 2024-01-22 18:24:08
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-28 14:27:39
 * @Description: 
-->
<template>
    <div class="flex flex-col bg-[#161F2CFF] pt-[44px] pb-[32px]">
        <div 
            class="flex bg-[#161F2CFF] text-center justify-between"
        >
            <span
                v-for="index in spans"
                :key="index"
                class="multiple-svg max-w-[86px] w-[19%]"
                :class="index !== boxIndex ? 'opacity-20' : ''"
                v-html="
                    setSvg(
                        currentBoxs[boxIndex].color,
                        currentBoxs[index].mutil + 'x',
                    )
                "
            ></span>
        </div>
        <p class="risk-label">{{ t.risk.charAt(0).toUpperCase() + t.risk.toLowerCase().slice(1) }}:{{ risk }}</p>
    </div>
</template>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import { oddsData, fnDataSetter } from '~/pages/casino/plinkoGame/data/oddsData';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import { useGameListSocket } from '@/socket/gamelist/index';
import { oGameName2Api } from '@/common/js/gameAbout';

const t = useTranslation()
const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});

enum Risk {
    High = 2,
    Medium = 1,
    Low = 0,
}
const boxIndex = ref(0);
const spans = ref([]);

const risk = ref('');
const oTheOdds = reactive(deepCopy(oddsData));

const currentBoxs = computed(() => {
    risk.value = Risk[props.history.sector];
    const Boxs = oTheOdds[risk.value][props.history.rows];

    return Boxs;
});

watch(() => props.history, (newVal) => {
    if (newVal){
        boxIndex.value = props.history.roll_array.reduce((a, b) => Number(a) + Number(b), 0);
        if (boxIndex.value <= 1){ // 下注结果是第一个或第二个倍率时
            spans.value = [
                0, 1, 2, 3, 4
            ]
        } else if (boxIndex.value === currentBoxs.value.length - 1){ // 下注结果是最后一个倍率时
            spans.value = [
                boxIndex.value - 4,
                boxIndex.value - 3,
                boxIndex.value - 2,
                boxIndex.value - 1,
                boxIndex.value
            ]
        } else if (boxIndex.value === currentBoxs.value.length - 2){ // 下注结果是倒数第二个倍率时
            spans.value = [
                boxIndex.value - 2,
                boxIndex.value - 1,
                boxIndex.value,
                boxIndex.value + 1
            ]
        } else {
            spans.value = [
                boxIndex.value - 2,
                boxIndex.value - 1,
                boxIndex.value,
                boxIndex.value + 1,
                boxIndex.value + 2
            ]
        }
    }
}, {
    deep: true,
    immediate: true
})
const setSvg = (color, value) => {
    let fill = color;
    return `<svg width="100%" height="100%" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 1.72C0 .32 1.76-.48 2.89.32 5.08 1.9 8.25 3.65 11.5 3.65c3.25 0 6.42-1.75 8.61-3.31 1.13-.8 2.89 0 2.89 1.4v14.65A2.6 2.6 0 0 1 20.42 19H2.58A2.6 2.6 0 0 1 0 16.38V1.72Z" fill=${fill}></path><foreignObject x="0" y="0" width="100%" height="100%" style="display:flex;align-items:center;justify-content: center;padding-top: 3px;"> <p class="svg-foreignObject">${value}</p> </foreignObject><g opacity=".48" filter="url(#a)"><path d="M0 1.71C0 .31 1.76-.49 2.89.32 5.08 1.9 8.25 3.64 11.5 3.64c3.25 0 6.42-1.75 8.61-3.32 1.13-.8 2.89 0 2.89 1.4v1.5c0-.34-.43-1.8-1.85-1.8-1.43 0-4.46 3.76-9.65 3.76-5.2 0-7.79-3.76-9.65-3.76C.43 1.42 0 2.52 0 3.22v-1.5Z" fill="#fff"></path></g><defs><filter id="a" x="0" y="0" width="23" height="5.18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2.08"></feOffset><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.48 0"></feColorMatrix><feBlend in2="shape" result="effect1_innerShadow_2174_144025"></feBlend></filter></defs></svg>`;
};

const fnGetPlinkoConfig = ()=>{
    const { EMIT_GET_GAME_CONFIG } = useGameListSocket();
    EMIT_GET_GAME_CONFIG(
        {game: oGameName2Api.plinkoGame},
        (oData)=>{
            if (!oData || oData.error) {
                console.error('查询游戏配置失败', oData); 
                return;
            }
            const { wins_map=[] } = oData.config as any; 
            if (!wins_map.length) return;
            fnDataSetter(oTheOdds, wins_map);
        }
    );
}

if (import.meta.client){
    fnGetPlinkoConfig();
}

</script>

<style scoped lang="scss">
.multiple-svg {
    position: relative;
    display: inline-block;

    svg {
        height: auto;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }

    :deep(.svg-foreignObject) {
        color: #fff;
        font-size: 8px;
        font-weight: 600;
        text-shadow: 0 0.770775px 1.54155px #095c21;
        white-space: nowrap;
    }

    @media (max-width: 460px) {
        .svg-foreignObject {
            padding-top: 28%;
        }
    }
}
.risk-label {
    color: #93acd3;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin: 23px 0 0;
    text-align: center;
    width: 100%;
}
</style>
